/**
 * @doc Editor
 */
export var NotificationType;
(function (NotificationType) {
    NotificationType["Success"] = "success";
    NotificationType["Error"] = "error";
    NotificationType["Warning"] = "warning";
    NotificationType["Info"] = "info";
})(NotificationType || (NotificationType = {}));
export var NotificationPresetTypes;
(function (NotificationPresetTypes) {
    NotificationPresetTypes["REPEATER_EDITOR_MAX_ITEMS"] = "repeaterMaxItemsEditorLimitation";
})(NotificationPresetTypes || (NotificationPresetTypes = {}));
//# sourceMappingURL=notifications.js.map